<template>
  <div class="installation-container tab-body flex-column h-100">
    <div class="custom-tab-body-cont">
      <b-row class="site-selector-container h-100">
        <b-col cols="3" class="flex-column groups-column pt-0">
          <div class="selector-title p-2">
            Groups
          </div>
          <div class="groups-wrapper px-2">
            <b-form-group>
              <b-form-checkbox stacked v-for="group in getCurrentFavoritesGroups" class="group-name pl-0 darkbg" size="md" :key="group.groupID" :checked="group.isSelected" @change="selectGroup(group,$event) ">{{group.name}}</b-form-checkbox>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="9" class="flex-column sites-column">
          <div class="sites-wrapper" style="overflow: unset;">
            <b-form-group>
              <b-form-checkbox-group id="checkboxes2" name="flavour2" v-model="selectedFavorites">
                <b-form-checkbox class="site-name-cont pl-0 favorite-checkbox blue-checked darkbg" size="md" v-for="favorite in favorites" :key="favorite.ID" :value="favorite.ID">
                  <span class="site-name" :title="favorite.name">
                    {{favorite.name}}
                  </span>
                  <div class="overflow-icon-container">
                    <b-dropdown variant="link" size="lg" no-caret>
                      <template slot="button-content">
                        <overflow-icon class="icon-default overflow show"></overflow-icon>
                      </template>
                      <b-dropdown-item @click="removeFavourite(favorite)">Remove</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="custom-tab-body-footer">
      <div class="d-flex justify-content-between">
          <div  class="text-left">
            <b-form inline v-if="showCreateForm ">
              <b-input class="mb-2 mr-sm-2 mb-sm-0 " v-model="newGroupName" id="inlineFormInputName2 " placeholder="Group name" />
              <b-button variant="outline-secondary " @click="createFavouriteGroup() ">Create</b-button>
            </b-form>
            <b-button v-if="!showCreateForm " type="button " variant="outline-secondary " @click="showCreateForm=true " :disabled="$v.selectedFavorites.$invalid">Create Favorite Group</b-button>
          </div>

          <div class="d-flex align-items-center">
            <b-form-checkbox v-model="clearDestination" size="m" class="installoptions w-0 darkbg mr-3">Overwrite if {{this.type=='plugins'?'plugin':'theme'}} exist</b-form-checkbox>
            <b-form-checkbox v-model="activate" size="m" class="installoptions darkbg mr-3">Activate after installation</b-form-checkbox>
            <div class="selected-label mr-3">{{selectedFavorites.length}} selected</div>
            <b-button variant="primary" @click="install" :disabled="$v.selectedFavorites.$invalid||$v.sites.$invalid">Install</b-button>
          </div>
      </div>
    </div>
  </div>

</template>

<script>
import DownIcon from '../../assets/down.svg';
import OverflowIcon from '../../assets/overflow.svg';
import Vue from 'vue';
import _ from 'lodash';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'favoriteinstaller',
  props: ['type', 'sites'],
  components: {
    DownIcon,
    OverflowIcon
  },
  mixins: [validationMixin],

  validations: {
    selectedFavorites: {
      required
    },
    sites: {
      required
    }
  },
  data() {
    return {
      selectedFavorites: [],
      clearDestination: false,
      showCreateForm: false,
      newGroupName: '',
      activate: false
    };
  },
  computed: {
    getCurrentFavoritesGroups() {
      let favorites = this.$store.getters.getFavorites.groups;
      let groups = _.filter(favorites, { type: this.type });
      return _.cloneDeep(groups);
    },
    getSelectedFavourites() {
      return _.filter(this.favorites, { selected: true });
    },
    favorites(){
      let currentFavorites = this.$store.getters.getFavorites.items;
      return _.filter(currentFavorites, { type: this.type });
    }
  },
  methods: {
    getFavorites() {
      let currentFavorites = this.$store.getters.getFavorites.items;
      return _.filter(currentFavorites, { type: this.type });
    },
    selectGroup(group, isSelected) {
      let favorites = this.getFavorites();
      _.each(favorites, favorite => {
        let groupIDs = favorite.groups;
        if (groupIDs) {
          let index = groupIDs.indexOf(group.groupID);
          if (index > -1) {
            if (isSelected) {
              let favIndex = this.selectedFavorites.indexOf(favorite.ID);
              if (favIndex === -1) {
                this.selectedFavorites.push(favorite.ID);
              }
            } else {
              this.selectedFavorites.splice(index, 1);
            }
          }
        }
      });
    },
    toggleFavorite($index, favorite) {
      favorite.selected = !favorite.selected;
      Vue.set(this.favorites, $index, favorite);
    },
    getSelectedSlugs() {
      let selectedFavorites = this.selectedFavorites;
      let favorites = this.getFavorites();
      let urls = _.map(selectedFavorites, selectedFavoriteId => {
        let favourite = _.find(favorites, { ID: selectedFavoriteId });
        return favourite.URL;
      });
      return urls;
    },
    getSelectedItemsCount() {
      return _.filter(this.favorites, { selected: true }).length;
    },
    install() {
      this.$emit('onInstall', {
        selectedItems: this.getSelectedSlugs(),
        type: this.type,
        clearDestination: this.clearDestination,
        activate: this.activate
      });
    },
    createFavouriteGroup() {
      let payload = {};
      payload.requiredData = {
        addToFavouritesGroup: {
          items: _.map(this.selectedFavorites, ID => {
            return 'f' + ID;
          }),
          gname: this.newGroupName,
          type: this.type
        },
        getFavouritesPluginsAndThemesV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.showCreateForm = false;
        this.$store.commit(
          'SET_FAVORITES',
          response.data.getFavouritesPluginsAndThemesV3
        );
      });
    },
    removeFavourite(favorite) {
      let payload = {
        requiredData: {
          removeFavourites: {
            name: favorite.name,
            URL: favorite.URL,
            type: favorite.type
          },
          getFavouritesPluginsAndThemesV3: 1
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.$store.commit(
          'SET_FAVORITES',
          response.data.getFavouritesPluginsAndThemesV3
        );
        this.loadFavorites();
      });
    },
    gotoWpRepo($event) {
      $event.stopPropagation();
      $event.preventDefault();
      this.$emit('gotoWpRepo');
    }
  }
};
</script>

<style scoped>
</style>
